import  { apiClient } from '@/shared/services/api';
import type { ApiResponse } from './authApi';

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  newPassword: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export interface ValidateTokenRequest {
  token: string;
}

export const passwordApi = {
  forgotPassword: async (payload: ForgotPasswordRequest): Promise<void> => {
    await apiClient.post<ApiResponse<null>>(
      '/Password/forgot-password',
      payload
    );
  },

  validateResetToken: async (
    payload: ValidateTokenRequest
  ): Promise<boolean> => {
    const { data } = await apiClient.post<
      ApiResponse<boolean>
    >('/Password/validate-reset-token', payload);
    return data.data;
  },

  resetPassword: async (payload: ResetPasswordRequest): Promise<void> => {
    await apiClient.post<ApiResponse<null>>(
      '/Password/reset-password',
      payload
    );
  },

  changePassword: async (payload: ChangePasswordRequest): Promise<void> => {
    await apiClient.post<ApiResponse<null>>(
      '/Password/change-password',
      payload
    );
  },
};